<template>
  <div>
    <h1>Products ({{ user.collections.length }} collections found in Shopify)</h1>
    <button class="appButton mt-2" @click="this.$router.push('/translations')">{{ $t('menu.settings.back') }}</button>
    <button class="appButton mt-2" @click="user.getCollections">{{ $t('menu.settings.refresh') }}</button>
  </div>

  <div class="flex flex-row">
    <!-- Left Column -->
    <div class="w-1/6 pt-4">
      <ul>
        <li v-for="collection in user.collections" :key="collection.id"
          class="cursor-pointer hover:bg-gray-dark hover:text-white p-2 rounded-md"
          :class="{ 'bg-gray-dark text-white': collection.id === this.selectedCollectionId }"
          @click="fetchCollectionByHandle(collection.idNumber)">
          {{ collection.title }}
        </li>
      </ul>
    </div>

    <!-- Right Column -->
    <div class="w-5/6 pt-4 pl-2">
      <div class="flex flex-wrap">
        <div class="w-full p-2">
          <div class="bg-dipit-dark text-white p-4 rounded-md">
            <div class="pb-4">DEFAULT LANGUAGE</div>
            <div class="w-full flex">
              <div class="w-1/2 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.en.title" class="font-normal text-black bg-gray" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.en.description"
                    class="font-normal field-sizing-fixed w-full h-24 text-black" /></div>

                <button v-if="user.userRoleId < 2" class="appButton mt-4 bg-dipit-light" @click="updateShopify('en', this.user.translations.en)">{{ $t('menu.settings.updateShopify') }} (ENG)</button>
                <button v-if="user.userRoleId < 2" class="appButton mt-4 bg-dipit-light" @click="copyAll()">{{ $t('menu.settings.copyAll') }}</button>
                <button v-if="user.userRoleId < 2" class="appButton mt-4 bg-dipit-light" @click="translateAll()">{{ $t('menu.settings.translateAll') }}</button>
                <button v-if="user.userRoleId < 2" class="appButton mt-4 bg-dipit-light" @click="storeInShopifyAll()">{{ $t('menu.settings.storeInShopifyAll') }}</button>           
              </div>
              <div class="w-1/2 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.en.seo_title.length) }})<input
                    v-model="this.user.translations.en.seo_title" class="font-normal text-black" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.en.seo_description.length) }})<textarea
                    v-model="this.user.translations.en.seo_description" class="font-normal field-sizing-fixed w-full h-24 text-black" />
                </div>
                <button class="appButton mt-4 bg-dipit-light" @click="copySeoAll()">{{ $t('menu.settings.copySeoAll') }}</button>
            <button class="appButton mt-4 bg-dipit-light" @click="translateSeoAll()">{{ $t('menu.settings.translateSeoAll') }}</button>
            <button class="appButton mt-4 bg-dipit-light" @click="storeInShopifySeoAll()">{{ $t('menu.settings.storeInShopifySeoAll') }}</button>           
              </div>
            </div>
          </div>
        </div>

        <!-- German -->
        <div class="w-1/2 p-2" v-show="this.user.translations.de.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/de.png" alt="German Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.de.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.de.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.de.seo_title.length) }})<input
                    v-model="this.user.translations.de.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.de.seo_description.length) }})<textarea
                    v-model="this.user.translations.de.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('de')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('de', this.user.translations.de)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('de', this.user.translations.de)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>

        <!-- Spanish -->
        <div class="w-1/2 p-2" v-show="this.user.translations.es.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/es.png" alt="Spanish Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.es.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.es.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.es.seo_title.length) }})<input
                    v-model="this.user.translations.es.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.es.seo_description.length) }})<textarea
                    v-model="this.user.translations.es.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('es')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('es', this.user.translations.es)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('es', this.user.translations.es)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>

        <!-- Danish -->
        <div class="w-1/2 p-2" v-show="this.user.translations.da.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/da.png" alt="Danish Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.da.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.da.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.da.seo_title.length) }})<input
                    v-model="this.user.translations.da.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.da.seo_description.length) }})<textarea
                    v-model="this.user.translations.da.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('da')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('da', this.user.translations.da)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('da', this.user.translations.da)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>        

        <!-- Dutch -->
        <div class="w-1/2 p-2" v-show="this.user.translations.nl.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/nl.png" alt="Dutch Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.nl.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.nl.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.nl.seo_title.length) }})<input
                    v-model="this.user.translations.nl.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.nl.seo_description.length) }})<textarea
                    v-model="this.user.translations.nl.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('nl')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('nl', this.user.translations.nl)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('nl', this.user.translations.nl)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>     

        <!-- French -->
        <div class="w-1/2 p-2" v-show="this.user.translations.fr.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/fr.png" alt="French Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.fr.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.fr.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.fr.seo_title.length) }})<input
                    v-model="this.user.translations.fr.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.fr.seo_description.length) }})<textarea
                    v-model="this.user.translations.fr.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('fr')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('fr', this.user.translations.fr)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('fr', this.user.translations.fr)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>     

        <!-- Swedish -->
        <div class="w-1/2 p-2" v-show="this.user.translations.sv.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/sv.png" alt="Swedish Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.sv.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.sv.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.sv.seo_title.length) }})<input
                    v-model="this.user.translations.sv.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.sv.seo_description.length) }})<textarea
                    v-model="this.user.translations.sv.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('sv')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('sv', this.user.translations.sv)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('sv', this.user.translations.sv)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>     

        <!-- UK -->
        <div class="w-1/2 p-2" v-show="this.user.translations.gb.visible == true">
          <div class="bg-white p-4 rounded-md">
            <img width="30" src="@/assets/img/flags/uk.png" alt="UK Flag" />
            <div class="w-full flex">
              <div class="w-1/3 p-2">
                <div class="font-bold mt-2">Title<input v-model="this.user.translations.gb.title" class="font-normal" />
                </div>
                <div class="font-bold mt-2">Description<textarea v-model="this.user.translations.gb.description"
                    class="font-normal field-sizing-fixed w-full h-24" /></div>
              </div>
              <div class="w-2/3 p-2">
                <div class="font-bold mt-2">SEO Title ({{ validateTitleLength(this.user.translations.gb.seo_title.length) }})<input
                    v-model="this.user.translations.gb.seo_title" class="font-normal" /></div>
                <div class="font-bold mt-2">SEO Description ({{ validateDescriptionLength(this.user.translations.gb.seo_description.length) }})<textarea
                    v-model="this.user.translations.gb.seo_description" class="font-normal field-sizing-fixed w-full h-24" />
                </div>
              </div>
            </div>
            <button class="appButton mt-2" @click="copyLocale('gb')">
              {{ $t('menu.settings.copy') }}
            </button>
            <button class="appButton mt-2" @click="updateLocale('gb', this.user.translations.gb)">
              {{ $t('menu.settings.update') }}
            </button>
            <button class="appButton mt-2" @click="updateShopify('gb', this.user.translations.gb)">
              {{ $t('menu.settings.updateShopify') }}
            </button>
          </div>
        </div>     

      </div>
    </div>
  </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
  mixins: [mixins],
  setup() {
    const user = useSettings();
    user.getCollections();

    return { user }
  },
  data() {
    return {
      collectionHandleData: '',
      selectedCollectionId: '',
      digests: []
    }
  },
  methods: {
    async fetchCollectionByHandle(idNumber) {
      const res = await this.user.getCollectionByHandle('Collection', idNumber);

      if (res) {
        this.collectionHandleData = res.data.translatableResource;
        this.selectedCollectionId = res.data.translatableResource.resourceId;

        this.digests = res.data.translatableResource.en.map(t => ({
          key: t.key,
          digest: t.digest
        }));

        // Reset translations object
        this.user.translations = {
          de: {
            visible: this.user.translations.de.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          es: {
            visible: this.user.translations.es.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          sv: {
            visible: this.user.translations.sv.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          fr: {
            visible: this.user.translations.fr.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          nl: {
            visible: this.user.translations.nl.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          da: {
            visible: this.user.translations.da.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          gb: {
            visible: this.user.translations.gb.visible,
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          },
          en: {
            title: '',
            description: '',
            seo_title: '',
            seo_description: ''
          }
        };

        // populate de object
        this.user.translations.de.title = this.collectionHandleData.de.find(t => t.key === 'title')?.value || '';
        this.user.translations.de.description = this.collectionHandleData.de.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.de.seo_title = this.collectionHandleData.de.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.de.seo_description = this.collectionHandleData.de.find(t => t.key === 'meta_description')?.value || '';

        // populate sv object
        this.user.translations.sv.title = this.collectionHandleData.sv.find(t => t.key === 'title')?.value || '';
        this.user.translations.sv.description = this.collectionHandleData.sv.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.sv.seo_title = this.collectionHandleData.sv.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.sv.seo_description = this.collectionHandleData.sv.find(t => t.key === 'meta_description')?.value || '';

        // populate es object
        this.user.translations.es.title = this.collectionHandleData.es.find(t => t.key === 'title')?.value || '';
        this.user.translations.es.description = this.collectionHandleData.es.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.es.seo_title = this.collectionHandleData.es.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.es.seo_description = this.collectionHandleData.es.find(t => t.key === 'meta_description')?.value || '';

        // populate fr object
        this.user.translations.fr.title = this.collectionHandleData.fr.find(t => t.key === 'title')?.value || '';
        this.user.translations.fr.description = this.collectionHandleData.fr.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.fr.seo_title = this.collectionHandleData.fr.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.fr.seo_description = this.collectionHandleData.fr.find(t => t.key === 'meta_description')?.value || '';

        // populate nl object
        this.user.translations.nl.title = this.collectionHandleData.nl.find(t => t.key === 'title')?.value || '';
        this.user.translations.nl.description = this.collectionHandleData.nl.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.nl.seo_title = this.collectionHandleData.nl.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.nl.seo_description = this.collectionHandleData.nl.find(t => t.key === 'meta_description')?.value || '';

        // populate dk object
        this.user.translations.da.title = this.collectionHandleData.da.find(t => t.key === 'title')?.value || '';
        this.user.translations.da.description = this.collectionHandleData.da.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.da.seo_title = this.collectionHandleData.da.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.da.seo_description = this.collectionHandleData.da.find(t => t.key === 'meta_description')?.value || '';

        // populate uk object
        this.user.translations.gb.title = this.collectionHandleData.en.find(t => t.key === 'title')?.value || '';
        this.user.translations.gb.description = this.collectionHandleData.en.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.gb.seo_title = this.collectionHandleData.en.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.gb.seo_description = this.collectionHandleData.en.find(t => t.key === 'meta_description')?.value || '';

        // populate eng default object
        this.user.translations.en.title = this.collectionHandleData.en.find(t => t.key === 'title')?.value || '';
        this.user.translations.en.description = this.collectionHandleData.en.find(t => t.key === 'body_html')?.value || '';
        this.user.translations.en.seo_title = this.collectionHandleData.en.find(t => t.key === 'meta_title')?.value || '';
        this.user.translations.en.seo_description = this.collectionHandleData.en.find(t => t.key === 'meta_description')?.value || '';
      }
    },
    async updateLocale(locale, langObj) {
      const fields = ['title', 'description', 'seo_title', 'seo_description'];

      for (const lang in this.user.translations) {
        if (lang === 'en') continue; // Skip English as it's the source
        if (lang !== locale) continue; // Only process the specified locale

        for (const field of fields) {
          if (this.user.translations[lang][field] === '') continue; // Skip empty fields

          const res = await this.user.getTranslations({
            locale: locale,
            text: this.user.translations[locale][field],
          });

          this.user.translations[locale][field] = res.translation;
        }
      }
    },
    async copyLocale(locale) {
      this.user.translations[locale].title = this.user.translations['en'].title;
      this.user.translations[locale].description = this.user.translations['en'].description;
      this.user.translations[locale].seo_title = this.user.translations['en'].seo_title;
      this.user.translations[locale].seo_description = this.user.translations['en'].seo_description;
    },   
    async updateShopify(locale, langObj) {
      const fields = ['title', 'description', 'seo_title','seo_description'];
      const resourceId = this.selectedCollectionId;

      for (const field of fields) {
        if (langObj[field] === '') continue;

        let key = '';
        let type = '';
        let mutation = '';
        let title = null;
        
        const escapedValue = await this.escapeGraphQLString(langObj[field]);

        if(locale === 'en') {
          if (field === 'title') key = 'title', type = 'single_line_text_field';
          if (field === 'description') key = 'body_html',  type = 'multi_line_text_field';
          if (field === 'seo_title') key = 'title_tag', type = 'single_line_text_field';
          if (field === 'seo_description') key = 'description_tag', type = 'single_line_text_field';

          mutation = `
            mutation {
              collectionUpdate(
                input: {
                  id: "${resourceId}",
                  metafields: [
                    {
                      namespace: "global",
                      key: "${key}",
                      type: "${type}",
                      value: "${escapedValue}"
                    }
                  ]
                }
              ) {
                collection {
                  id
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `;

        } else {
          if (field === 'title') key = 'title', type = 'single_line_text_field';
          if (field === 'description') key = 'body_html', type = 'multi_line_text_field';
          if (field === 'seo_title') key = 'meta_title', type = 'single_line_text_field';
          if (field === 'seo_description') key = 'meta_description', type = 'single_line_text_field';

          const digest = this.digests.find(d => d.key === key)?.digest || '';

          mutation = `
            mutation {
              translationsRegister(
                resourceId: "${resourceId}",
                translations: [
                  {
                    locale: "${locale}",
                    key: "${key}",
                    value: "${escapedValue}",
                    translatableContentDigest: "${digest}"
                  }
                ]
              ) {
                userErrors {
                  field
                  message
                }
              }
            }
          `;
        }

        try {
          const res = await this.user.saveTranslations(mutation);

        } catch (error) {
          console.error('Fejl ved opdatering:', error.response?.data || error.message);
        }
      }
    },
    async escapeGraphQLString(str) {
      return str
          .replace(/\\/g, '\\\\')   // escape backslashes
          .replace(/"""/g, '\\"""') // escape triple quotes
          .replace(/"/g, '\\"');    // escape double quotes
    },
    async copyAll() {
      const fields = ['title', 'description', 'seo_title', 'seo_description'];

      for (const lang in this.user.translations) {
        if (lang === 'en') continue; // Skip English as it's the source

        fields.forEach(field => {
          this.user.translations[lang][field] = this.user.translations['en'][field];
        });
      }
    },
    async copySeoAll() {
      const fields = ['seo_title', 'seo_description'];

      for (const lang in this.user.translations) {
        if (lang === 'en') continue; // Skip English as it's the source

        fields.forEach(field => {
          this.user.translations[lang][field] = this.user.translations['en'][field];
        });
      }
    },
    async translateSeoAll() {
      const fields = ['seo_title', 'seo_description'];

      for (const lang in this.user.translations) {
        if (lang === 'en') continue; // Skip English as it's the source
        if (lang === 'gb') continue; // Skip Great Britain as it's the source

        for (const field of fields) {
          if (this.user.translations[lang][field] === '') continue; // Skip empty fields

          const res = await this.user.getTranslations({
            locale: lang,
            text: this.user.translations['en'][field],
          });

          this.user.translations[lang][field] = res.translation;
        }
      }
    },
    async translateAll() {
      const fields = ['title', 'description', 'seo_title', 'seo_description'];

      for (const lang in this.user.translations) {
        if (lang === 'en') continue; // Skip English as it's the source
        if (lang === 'gb') continue; // Skip Great Britain as it's the source

        for (const field of fields) {
          if (this.user.translations[lang][field] === '') continue; // Skip empty fields

          const res = await this.user.getTranslations({
            locale: lang,
            text: this.user.translations['en'][field],
          });

          this.user.translations[lang][field] = res.translation;
        }
      }
    }
  },
    validateTitleLength(length) {
      if (length > 70) {
        return `Too long by ${length - 70} characters`;
      } else {
        return `${length}/70 characters`;
      }
    },
    validateDescriptionLength(length) {
      if (length > 160) {
        return `Too long by ${length - 160  } characters`;
      } else {
        return `${length}/160 characters`;
      }
    },
    async storeInShopifyAll() {
      const langs = Object.keys(this.user.translations.userLangs).filter(
        lang => this.user.translations.userLangs[lang].visible
      );
      for (const lang of langs) {
        await this.updateShopify(lang, this.user.translations[lang]);
      }
      await this.updateShopify('en', this.user.translations.en);
    },
    async storeInShopifySeoAll() {
      const langs = Object.keys(this.user.translations.userLangs).filter(
        lang => this.user.translations.userLangs[lang].visible
      );
      for (const lang of langs) {
        await this.updateShopify(lang, {
          seo_title: this.user.translations[lang].seo_title,
          seo_description: this.user.translations[lang].seo_description
        });
      }
    }
  }
</script>

<style scoped>
input,
textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
}
</style>